import { render, staticRenderFns } from "./SendingMessage.vue?vue&type=template&id=043ef52c&"
import script from "./SendingMessage.vue?vue&type=script&lang=js&"
export * from "./SendingMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports